export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "retry_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relancer l'analyse"])}
      },
      "en": {
        "retry_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retry analysis"])}
      }
    }
  })
}
